import { Alert } from "@mantine/core";
import { IconAlertCircle } from "@tabler/icons-react";

interface Props {
  error: string | null;
}

export function SystemEmailModeError({ error }: Props) {
  return error ? (
    <Alert
      color="red"
      icon={<IconAlertCircle size={18} />}
      title="Mode not changed"
    >
      {error}
    </Alert>
  ) : null;
}
